/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Product Offerings Modal Suggest Inquiry Component
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.10.0
 */

import { useCallback } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationWizardProductOfferings } from '../../../modules/internationalization/intSelectors';
import { IWizardProductOfferingsTranslation } from '../../../modules/internationalization/types';
import { IModalPopup } from '../../../modules/modal/components/ModalPopup';
import {
    ModalPopupContainerStyled,
    ModalPopupControlContainer,
    ModalPopupTextStyled,
    ModalPopupTitleStyled,
} from '../../../modules/modal/components/styled/ModalStyled';
import ButtonServiceUserDenied from '../../../modules/role/components/ButtonServiceUserDenied';
import { IRootReducer } from '../../../reducers/rootReducer';
import { productOfferingsCreateInquiryAction } from '../wizardProductOfferingsActions';

type TProductOfferingsModalSuggestInquiryProps =
    IModalPopup
    & IConnectedProps
    & IDispatchProps;

const ProductOfferingsModalSuggestInquiry = (props: TProductOfferingsModalSuggestInquiryProps) => {

    const {
        createInquiry,
        onCloseModal,
        wizardProductOfferingsTranslation,
    } = props;

    const onButtonClick = useCallback(() => {
        onCloseModal();

        createInquiry();
    }, [onCloseModal]);

    return (
        <ModalPopupContainerStyled
            data-component={'modal-popup'}
            data-name={props.dataName}
            width="490px">
            <ModalPopupTitleStyled data-name="modal-popup-title">
                {wizardProductOfferingsTranslation.wizardModalSuccess.inquiry.suggestTitle}
            </ModalPopupTitleStyled>
            <ModalPopupTextStyled data-name="modal-popup-text">
                {wizardProductOfferingsTranslation.wizardModalSuccess.inquiry.suggestText}
            </ModalPopupTextStyled>
            <ModalPopupControlContainer style={{ display: 'flex' }}>
                <ButtonServiceUserDenied dataName="close-button" onClick={onButtonClick}>
                    {wizardProductOfferingsTranslation.wizardModalSuccess.inquiry.suggestAccept}
                </ButtonServiceUserDenied>
            </ModalPopupControlContainer>
        </ModalPopupContainerStyled>
    );
};

interface IConnectedProps {
    wizardProductOfferingsTranslation: IWizardProductOfferingsTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    wizardProductOfferingsTranslation: makeSelectTranslationWizardProductOfferings(),
});

export interface IDispatchProps {
    createInquiry: () => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    createInquiry: () => dispatch(productOfferingsCreateInquiryAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductOfferingsModalSuggestInquiry);
